var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'unstuck': _vm.unstuck},attrs:{"id":"header"}},[_c('CookieBanner',{class:{'unstuck': _vm.unstuck},on:{"cookieBanner":_vm.handleCookieBanner}}),_vm._v(" "),_c('header',{class:{ header: true, bump: _vm.cookieBannerOpen, 'unstuck': _vm.unstuck }},[_c('img',{staticClass:"header-logo",attrs:{"src":require("../assets/images/logo@2x.png"),"alt":"logo"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85874ce0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 382
// module chunks = 0